module.exports = __webpack_public_path__ + "static/img/defender1.7d28f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/defender1.png
// module id = n/on
// module chunks = 0